import { render, staticRenderFns } from "./NearestSchools.vue?vue&type=template&id=89531d04&scoped=true&lang=pug&"
import script from "./NearestSchools.vue?vue&type=script&lang=js&"
export * from "./NearestSchools.vue?vue&type=script&lang=js&"
import style0 from "./NearestSchools.vue?vue&type=style&index=0&id=89531d04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89531d04",
  null
  
)

export default component.exports